"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var types_1 = require("./types");
var context_1 = require("./context");
var initLDClient_1 = __importDefault(require("./initLDClient"));
var utils_1 = require("./utils");
/**
 * The `LDProvider` is a component which accepts a config object which is used to
 * initialize `launchdarkly-js-client-sdk`.
 *
 * This Provider does three things:
 * - It initializes the ldClient instance by calling `launchdarkly-js-client-sdk` initialize on `componentDidMount`
 * - It saves all flags and the ldClient instance in the context API
 * - It subscribes to flag changes and propagate them through the context API
 *
 * Because the `launchdarkly-js-client-sdk` in only initialized on `componentDidMount`, your flags and the
 * ldClient are only available after your app has mounted. This can result in a flicker due to flag changes at
 * startup time.
 *
 * This component can be used as a standalone provider. However, be mindful to only include the component once
 * within your application. This provider is used inside the `withLDProviderHOC` and can be used instead to initialize
 * the `launchdarkly-js-client-sdk`. For async initialization, check out the `asyncWithLDProvider` function
 */
var LDProvider = /** @class */ (function (_super) {
    __extends(LDProvider, _super);
    function LDProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.getReactOptions = function () { return (__assign(__assign({}, types_1.defaultReactOptions), _this.props.reactOptions)); };
        _this.subscribeToChanges = function (ldClient) {
            var targetFlags = _this.props.flags;
            ldClient.on('change', function (changes) {
                var flattened = (0, utils_1.getFlattenedFlagsFromChangeset)(changes, targetFlags, _this.getReactOptions());
                if (Object.keys(flattened).length > 0) {
                    _this.setState(function (_a) {
                        var flags = _a.flags;
                        return ({ flags: __assign(__assign({}, flags), flattened) });
                    });
                }
            });
        };
        _this.initLDClient = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, clientSideID, flags, options, user, ldClient, reactOptions, fetchedFlags, initialisedOutput;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, clientSideID = _a.clientSideID, flags = _a.flags, options = _a.options, user = _a.user;
                        return [4 /*yield*/, this.props.ldClient];
                    case 1:
                        ldClient = _b.sent();
                        reactOptions = this.getReactOptions();
                        if (!ldClient) return [3 /*break*/, 2];
                        fetchedFlags = (0, utils_1.fetchFlags)(ldClient, reactOptions, flags);
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, (0, initLDClient_1.default)(clientSideID, user, reactOptions, options, flags)];
                    case 3:
                        initialisedOutput = _b.sent();
                        fetchedFlags = initialisedOutput.flags;
                        ldClient = initialisedOutput.ldClient;
                        _b.label = 4;
                    case 4:
                        this.setState({ flags: fetchedFlags, ldClient: ldClient });
                        this.subscribeToChanges(ldClient);
                        return [2 /*return*/];
                }
            });
        }); };
        var options = props.options;
        _this.state = {
            flags: {},
            ldClient: undefined,
        };
        if (options) {
            var bootstrap = options.bootstrap;
            if (bootstrap && bootstrap !== 'localStorage') {
                var useCamelCaseFlagKeys = _this.getReactOptions().useCamelCaseFlagKeys;
                var flags = useCamelCaseFlagKeys ? (0, utils_1.camelCaseKeys)(bootstrap) : bootstrap;
                _this.state = {
                    flags: flags,
                    ldClient: undefined,
                };
            }
        }
        return _this;
    }
    LDProvider.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, user, deferInitialization;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, user = _a.user, deferInitialization = _a.deferInitialization;
                        if (deferInitialization && !user) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.initLDClient()];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LDProvider.prototype.componentDidUpdate = function (prevProps) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, user, deferInitialization, userJustLoaded;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, user = _a.user, deferInitialization = _a.deferInitialization;
                        userJustLoaded = !prevProps.user && user;
                        if (!(deferInitialization && userJustLoaded)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.initLDClient()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    LDProvider.prototype.render = function () {
        return react_1.default.createElement(context_1.Provider, { value: this.state }, this.props.children);
    };
    return LDProvider;
}(react_1.Component));
exports.default = LDProvider;
//# sourceMappingURL=provider.js.map